<template>
  <div class="login-wrapper">
    <header class="auth-brand" aria-label="Brand">
      <div class="brand-mark" aria-hidden="true"></div>
      <div class="auth-brand__name">taption</div>
    </header>

    <section ref="authenticationform" class="authentication-form">
      <div ref="logincontainer" class="login-container">
        <div class="login-surface">
          <div class="login-card">
            <div class="login-header">
              <h1 class="title">
                <span>{{$lang.login.member_login}}</span>
              </h1>
            </div>

            <div class="login-info">
              <div class="login-desc" v-html="$lang.login.login_desc"></div>
              <div class="referral-note">*{{$lang.login.referral_note}}</div>
            </div>

            <form class="login-form" autocomplete="on" @submit.prevent="login">
            <div class="field">
              <label class="field-label">{{$lang.login.email_address}}</label>
              <input
                v-model="email"
                autocomplete="username"
                :disabled="isLoginLoading"
                type="email"
                class="field-input"
                :placeholder="$lang.login.email_address"
              />
            </div>

            <div class="field">
              <label class="field-label">{{$lang.login.password}}</label>
              <div class="field-input-wrap">
                <input
                  v-model="password"
                  :disabled="isLoginLoading"
                  :type="showpassword ? 'password' : 'text'"
                  name="login[password]"
                  autocomplete="current-password"
                  class="field-input field-input--password"
                  :placeholder="$lang.login.password"
                />
                <button
                  class="field-action"
                  type="button"
                  :disabled="isLoginLoading"
                  @click="showpassword = !showpassword"
                >{{ showpassword ? 'Show' : 'Hide' }}</button>
              </div>
            </div>

            <div class="form-button">
              <v-btn
                class="login-button"
                elevation="0"
                color="primary"
                :loading="isLoginLoading"
                :disabled="isLoginLoading"
                type="submit"
              >{{$lang.login.login}}</v-btn>
            </div>
          </form>
          </div>

          <div class="login-footer">
            <div class="terms-privacy">
              {{$lang.login.term_of_service_description1}}<a @click="onTerms">{{$lang.login.term_of_service}}</a>
              {{$lang.login.term_of_service_description2}}<a @click="onPrivacy">{{$lang.login.privacy_policy}}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import systemConnection from '@/connections/system.service'
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      loginError: "",
      errorCode: "",
      showpassword: true,
      isLoginLoading: false
    };
  },
  methods: {
    login: function() {
      const me = this;
      me.isLoginLoading = true;
    //  me.$store.dispatch('reset')
    systemConnection.getUserLoginPromise(me.email, me.password)
        .then(
          function() {
            me.$router.push({ name: "home" });
          },
          function() {
            // me.loginError = me.$lang.error[err.code];
            // me.errorCode = err.code;
          }
        )
        .finally(function() {
          me.isLoginLoading = false;
        });
    },
    onPrivacy(){
      const me = this;
      const routeData = me.$router.resolve({name: 'privacy'});
      window.open(routeData.href, '_blank');
    },
    onTerms(){
      const me = this;
      const routeData = me.$router.resolve({name: 'terms'});
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {
    const me = this;
    setTimeout(function() {
      me.$refs.logincontainer.classList.add("show");
    }, 100);
  }
};
</script>
<style scoped>
  h1.title {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0px !important;
}
.login-wrapper {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background-color: #f6f9fc;
  background-image:
    linear-gradient(0deg, rgba(15, 23, 42, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, 0.035) 1px, transparent 1px);
  background-size: 120px 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-wrapper::before {
  content: "";
  position: absolute;
  left: -30vw;
  top: -55vh;
  width: 160vw;
  height: 115vh;
  pointer-events: none;
  background-image:
    radial-gradient(42% 70% at 18% 22%, rgba(60, 206, 189, 0.70), transparent 62%),
    radial-gradient(50% 85% at 55% 35%, rgba(74, 110, 224, 0.72), transparent 64%),
    radial-gradient(52% 90% at 85% 22%, rgba(124, 58, 237, 0.74), transparent 62%),
    linear-gradient(110deg, rgba(60, 206, 189, 0.98) 0%, rgba(74, 110, 224, 0.92) 42%, rgba(124, 58, 237, 0.88) 100%);
  background-size: 200% 200%;
  background-position: 0% 50%;
  clip-path: polygon(0 0, 100% 0, 100% 52%, 0 78%);
  transform: skewY(-10deg);
  transform-origin: top left;
  filter: saturate(1.15);
  opacity: 0.95;
  animation: authWave 28s ease-in-out infinite;
}

.login-wrapper::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(80% 60% at 50% 20%, rgba(255, 255, 255, 0.70) 0%, rgba(255, 255, 255, 0) 60%),
    radial-gradient(90% 70% at 50% 110%, rgba(15, 23, 42, 0.06) 0%, rgba(15, 23, 42, 0) 55%);
}

@keyframes authWave {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 45%; }
  100% { background-position: 0% 50%; }
}

@media (prefers-reduced-motion: reduce) {
  .login-wrapper::before {
    animation: none;
  }
}

.authentication-form {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  position: relative;
  z-index: 1;
}

.auth-brand {
  position: absolute;
  top: 28px;
  left: 28px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  z-index: 2;
  user-select: none;
}
.auth-brand__name {
  font-weight: 700;
  font-size: 40px;
  letter-spacing: 0;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 8px 22px rgba(15, 23, 42, 0.28);
}

.login-container {
  width: 440px;
  max-width: calc(100vw - 40px);
  transition: transform 220ms ease, opacity 220ms ease;
  opacity: 0;
  transform: translateY(6px);
}
.login-container.show {
  opacity: 1;
  transform: translateY(0);
}

.login-header {
  padding: 28px 28px 10px;
}
.brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 9px;
  background-color: rgba(255, 255, 255, 0.92);
  background-image: url("~@/assets/logo.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.25);
  flex-shrink: 0;
}
.title {
  margin: 0 !important;
  font-size: 26px;
  line-height: 1.2;
  color: #0b1220;
  letter-spacing: 0;
}

.login-surface {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.10);
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16);
  overflow: hidden;
}

.login-info {
  padding: 0 28px 8px;
}
.login-desc {
  color: rgba(15, 23, 42, 0.80);
  font-size: 16px;
  line-height: 1.55;
  margin-bottom: 0 !important;
}
.referral-note {
  margin-top: 10px !important;
  margin-bottom: 0 !important;
  color: rgba(15, 23, 42, 0.55);
  font-size: 12px;
}

.login-form {
  padding: 18px 28px 24px;
}

.field {
  margin-bottom: 18px !important;
}
.field-label {
  display: block;
  margin-bottom: 8px !important;
  font-size: 14px;
  font-weight: 600;
  color: #353A44;
  letter-spacing: 0;
}
.field-input-wrap {
  position: relative;
  display: block;
}
.field-input {
  width: 100% !important;
  height: 44px !important;
  padding: 0 12px !important;
  border-radius: 8px !important;
  border: 1px solid rgba(15, 23, 42, 0.14) !important;
  background: #ffffff !important;
  color: #0b1220 !important;
  font-size: 16px !important;
  outline: none !important;
  box-sizing: border-box !important;
  transition: border-color 140ms ease, box-shadow 140ms ease !important;
}
.field-input--password {
  padding-right: 90px !important;
}
.field-input:focus {
  border-color: rgba(60, 206, 189, 0.75) !important;
  box-shadow: 0 0 0 3px rgba(60, 206, 189, 0.15) !important;
}
.field-input::placeholder {
  color: rgba(15, 23, 42, 0.40);
}
.field-input:disabled {
  opacity: 0.65;
  background: rgba(15, 23, 42, 0.02) !important;
}

.field-action {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  height: 28px;
  padding: 0 6px !important;
  margin: 0 !important;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: rgba(15, 23, 42, 0.65);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  z-index: 10;
  transition: color 120ms ease, opacity 120ms ease;
  white-space: nowrap;
}
.field-action:hover:not(:disabled) {
  color: #2eb3a3;
  text-decoration: underline;
}
.field-action:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.form-button {
  margin-top: 20px !important;
  margin-bottom: 0 !important;
}
.login-button {
  width: 100% !important;
  height: 44px !important;
  border-radius: 9px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  letter-spacing: 0 !important;
  box-shadow: 0 10px 24px rgba(60, 206, 189, 0.28) !important;
}

.terms-privacy {
  margin: 0 !important;
  padding: 16px 28px !important;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(15, 23, 42, 0.02);
  color: rgba(15, 23, 42, 0.58);
  font-size: 14px;
  line-height: 1.6;
  letter-spacing: 0;
}
.terms-privacy a {
  color: #3CCEBD;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: color 120ms ease;
}
.terms-privacy a:hover {
  color: #2eb3a3;
  text-decoration: underline;
}

@media (max-width: 600px) {
  .authentication-form {
    padding: 30px 16px;
  }
  .login-container {
    max-width: calc(100vw - 32px);
  }
  .auth-brand {
    top: 18px;
    left: 18px;
  }
  .auth-brand__name {
    font-size: 30px;
  }
  .login-form {
    padding: 18px 20px 22px;
  }
  .login-info {
    padding: 0 20px 6px;
  }
  .login-header {
    padding: 24px 20px 8px;
  }
}
</style>
